"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StoreModule = /** @class */ (function () {
    function StoreModule(path, initialState) {
        this.reducers = {};
        this.selectors = {};
        this.path = path;
        this.initialState = initialState;
    }
    StoreModule.prototype.setPayloadAction = function (type, logic, tinyReducer) {
        this.reducers[type] = tinyReducer;
        return {
            type: { type: type, payload: undefined },
            action: function (payload) { return ({ type: type, payload: logic(payload) }); },
        };
    };
    StoreModule.prototype.setSimpleAction = function (type, tinyReducer) {
        this.reducers[type] = tinyReducer;
        return { type: { type: type }, action: function () { return ({ type: type }); } };
    };
    StoreModule.prototype.getReducer = function () {
        var _this = this;
        return function (state, action) {
            if (state === void 0) { state = _this.initialState; }
            var thisReducer = _this.reducers[action.type];
            if (thisReducer)
                return thisReducer(state, action);
            return state;
        };
    };
    StoreModule.prototype.helper = function (state, separator) {
        if (separator === void 0) { separator = "."; }
        return this.resolve(this.path, state, separator);
    };
    StoreModule.prototype.resolve = function (path, object, separator) {
        if (separator === void 0) { separator = "."; }
        return path.split(separator).reduce(function (r, val) { return (r ? r[val] : undefined); }, object);
    };
    return StoreModule;
}());
exports.StoreModule = StoreModule;
//# sourceMappingURL=StoreModule.js.map